// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-container {
    font-family: Arial, sans-serif;
    max-width: 573px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: end;
}
  
  .payment-item {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    background-color: #fff;
    display: flex;
    width: 100%;
  }
  
  .payment-header {
    display: flex;
    align-items: center;
    justify-content: start;
  }
  
  .payment-header .icon {
    margin-right: 8px;
    width: 48px;
    height: 48px;
    background: #F8F9FA;
    border-radius: 37px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  img.zelleImage {
    margin-right: 8px;
   }

  .card-logos img,
  .zelle-logo {
    width: 50px;
    margin-left: 8px;
  }
  
  .pay-btn {
    background-color: #b22222;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 4px;
    width: 100%;
    cursor: pointer;
    font-size: 16px;
  }
  
.payment-item input {
    margin-top: 0px;
}

.payment-header img {
    width: 48px;
    height: 48px;
}

.payment-header .icon {
    margin-right: 8px;
    width: 48px;
    background: #F8F9FA;
    border-radius: 37px;
}

.icon img.cardImage {
    width: 24px;
    height: 24px;
}

.card-logos {
    display: flex;
    justify-content: end;
    align-items: center;
    width: 340px;
}

.payment-item label {
    width: 100%;
}

.payment-options-btns{
    display: flex;
    justify-content: end;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/PaymentOptions/styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;EAEE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;GAClB;;EAED;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;AAEF;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;AACf","sourcesContent":[".payment-container {\n    font-family: Arial, sans-serif;\n    max-width: 573px;\n    margin: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n}\n  \n  .payment-item {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 16px;\n    margin-bottom: 16px;\n    background-color: #fff;\n    display: flex;\n    width: 100%;\n  }\n  \n  .payment-header {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n  }\n  \n  .payment-header .icon {\n    margin-right: 8px;\n    width: 48px;\n    height: 48px;\n    background: #F8F9FA;\n    border-radius: 37px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  img.zelleImage {\n    margin-right: 8px;\n   }\n\n  .card-logos img,\n  .zelle-logo {\n    width: 50px;\n    margin-left: 8px;\n  }\n  \n  .pay-btn {\n    background-color: #b22222;\n    color: white;\n    padding: 10px;\n    border: none;\n    border-radius: 4px;\n    width: 100%;\n    cursor: pointer;\n    font-size: 16px;\n  }\n  \n.payment-item input {\n    margin-top: 0px;\n}\n\n.payment-header img {\n    width: 48px;\n    height: 48px;\n}\n\n.payment-header .icon {\n    margin-right: 8px;\n    width: 48px;\n    background: #F8F9FA;\n    border-radius: 37px;\n}\n\n.icon img.cardImage {\n    width: 24px;\n    height: 24px;\n}\n\n.card-logos {\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    width: 340px;\n}\n\n.payment-item label {\n    width: 100%;\n}\n\n.payment-options-btns{\n    display: flex;\n    justify-content: end;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
